import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import "./custom-checkbox-component.scss";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  color?: string;
  label: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  color,
  label,
}) => {
  return (
    <div className="checkbox-container" onClick={() => onChange(!checked)}>
      <div
        className={`custom-check-box ${color ? "colored" : ""}`}
        style={
          color
            ? { backgroundColor: color, borderColor: color }
            : { backgroundColor: "white" }
        }
      >
        {color
          ? checked && <CheckIcon fontSize="small" className="tick" />
          : checked &&
            !color && <CheckIcon fontSize="small" className="tick-plain" />}
      </div>
      {label && <span className="checkbox-label">{label}</span>}
    </div>
  );
};

export default CustomCheckbox;
